import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { ArrowRight, ArrowDown } from "lucide-react";
import { HERO_IMAGE, waUrl } from "../data";
import { WindowWatermark } from "./Logo";
import { scrollToId } from "../lib/scroll";

const LINES = ["Ventanas de PVC", "y aluminio", "en Cantabria."];

const lineVariant = {
  hidden: { y: "110%" },
  show: (i) => ({ y: "0%", transition: { duration: 0.9, delay: 1 + i * 0.16, ease: [0.22, 1, 0.36, 1] } }),
};

const scrollTo = scrollToId;

export const Hero = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end start"] });
  const bgY = useTransform(scrollYProgress, [0, 1], ["0%", "18%"]);

  return (
    <section id="inicio" ref={ref} className="relative min-h-screen flex flex-col justify-end overflow-hidden bg-ink">
      {/* Fondo de marca (o foto real si defines HERO_IMAGE) */}
      <motion.div style={{ y: bgY }} className="absolute inset-0 -z-0">
        {HERO_IMAGE ? (
          <img src={HERO_IMAGE} alt="Trabajo de Ventanas Hondal en Cantabria" className="w-full h-full object-cover" />
        ) : (
          <div className="w-full h-full bg-gradient-to-br from-[#0A2540] via-[#0d2f52] to-[#061a2e]" />
        )}
        <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/50 to-ink/20" />
        {/* Marca de agua sutil */}
        <WindowWatermark className="absolute -right-8 top-1/2 -translate-y-1/2 h-[85%] w-auto text-white/[0.08]" />
        {/* Retícula fina */}
        <div className="absolute inset-0 opacity-[0.06]" style={{ backgroundImage: "linear-gradient(#fff 1px, transparent 1px), linear-gradient(90deg, #fff 1px, transparent 1px)", backgroundSize: "80px 80px" }} />
      </motion.div>

      <div className="relative z-10 max-w-7xl mx-auto w-full px-6 lg:px-10 pb-16 lg:pb-24">
        <motion.span
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1, delay: 0.6 }}
          className="block mb-5 text-[11px] sm:text-xs uppercase tracking-[0.25em] font-bold text-electric"
          data-testid="hero-overline"
        >
          Iván Hondal López · Montaje y reparación · Cantabria
        </motion.span>
        <h1 className="font-heading font-black text-white text-5xl sm:text-7xl lg:text-8xl tracking-tighter leading-[0.92]">
          {LINES.map((line, i) => (
            <span key={i} className="block overflow-hidden">
              <motion.span custom={i} variants={lineVariant} initial="hidden" animate="show" className="block">{line}</motion.span>
            </span>
          ))}
        </h1>

        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, delay: 2.1 }} className="mt-10 flex flex-col sm:flex-row gap-5 sm:items-center">
          <p className="max-w-md text-white/80 text-base md:text-lg leading-relaxed">
            Cerramientos de PVC y aluminio, conversión a oscilobatiente, mosquiteras a
            medida, persianas y estores. Acabados de calidad cuidando cada detalle.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 self-start">
            <a href={waUrl()} target="_blank" rel="noopener noreferrer" data-testid="hero-cta-button" className="group inline-flex items-center justify-center gap-3 bg-electric text-white font-semibold px-7 py-4 hover:bg-white hover:text-ink transition-colors duration-300">
              Pedir presupuesto
              <ArrowRight size={20} className="group-hover:translate-x-1 transition-transform duration-300" />
            </a>
            <button onClick={() => scrollTo("servicios")} data-testid="hero-services-button" className="inline-flex items-center justify-center gap-2 border border-white/30 text-white font-semibold px-7 py-4 hover:bg-white/10 transition-colors duration-300">
              Ver servicios
              <ArrowDown size={18} />
            </button>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
